export default {
  computed: {
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },

  methods: {
    formatPrice(str) {
      return this.$numeral(str).format('$0,0');
    },
  },
};
